module.exports = __webpack_public_path__ + "static/img/second_service.8c3d322.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/second_service.png
// module id = 6T2e
// module chunks = 0